/**
 * Application-wide constants
 *
 * Extracted from database-cache.service.ts for better separation of concerns.
 * These constants define code/description mappings for various domain concepts.
 */

import {
  STAFF_JOB_TITLES_I18N,
  STAFF_ROLES_I18N,
  QUOTA_MODELS_I18N,
  SECTION_GROUP_ADMIN_ROLES_I18N,
  SYSTEM_ADMIN_ROLES_I18N,
  SECTION_GROUP_FUNCTIONS_I18N,
  USER_JOB_TITLES_I18N,
  STATUS_I18N,
  PRICING_MODEL_I18N,
  SECTION_GROUP_CONTRACT_CHANNEL_I18N,
  SECTION_BILL_TO_TYPE_I18N,
  PAYMENT_METHOD_I18N,
} from './app-constants.i18n';

export const STAFF_JOB_TITLES = [
  { code: "MD", desc: STAFF_JOB_TITLES_I18N.MD },
  { code: "DDS", desc: STAFF_JOB_TITLES_I18N.DDS },
  { code: "DH", desc: STAFF_JOB_TITLES_I18N.DH },
  { code: "NS", desc: STAFF_JOB_TITLES_I18N.NS },
  { code: "PT", desc: STAFF_JOB_TITLES_I18N.PT },
  { code: "OT", desc: STAFF_JOB_TITLES_I18N.OT },
  { code: "ST", desc: STAFF_JOB_TITLES_I18N.ST },
  { code: "RD", desc: STAFF_JOB_TITLES_I18N.RD },
  { code: "CW", desc: STAFF_JOB_TITLES_I18N.CW },
  { code: "OTHER", desc: STAFF_JOB_TITLES_I18N.OTHER }
];

export const STAFF_ROLES = [
  { code: "PRIMARY", desc: STAFF_ROLES_I18N.PRIMARY },
  { code: "ACCOUNT_MANAGEMENT", desc: STAFF_ROLES_I18N.ACCOUNT_MANAGEMENT },
  { code: "USER_MANAGEMENT", desc: STAFF_ROLES_I18N.USER_MANAGEMENT },
  { code: "MEASUREMENT", desc: STAFF_ROLES_I18N.MEASUREMENT },
  { code: "REFER", desc: STAFF_ROLES_I18N.REFER }
];

export const QUOTA_MODELS = [
  { code: "SHARED", desc: QUOTA_MODELS_I18N.SHARED },
  { code: "DEDICATED", desc: QUOTA_MODELS_I18N.DEDICATED }
];

export const SECTION_GROUP_ADMIN_ROLES = [
  { code: "SECTION_MANAGEMENT", desc: SECTION_GROUP_ADMIN_ROLES_I18N.SECTION_MANAGEMENT },
  { code: "SECTION_GROUP_ADMIN_MANAGEMENT", desc: SECTION_GROUP_ADMIN_ROLES_I18N.SECTION_GROUP_ADMIN_MANAGEMENT }
];

export const SECTION_GROUP_ADMIN_ROLES_MUST_HAVE = [
  { code: "SECTION_GROUP_UPDATE", desc: SECTION_GROUP_ADMIN_ROLES_I18N.SECTION_GROUP_UPDATE }
];

export const  SECTION_GROUP_ADMIN_ROLES_NOT_DISTRIBUTOR_AGENT = [
    { code: "SECTION_GROUP_BILLING_INFO_MANAGEMENT", desc:SECTION_GROUP_ADMIN_ROLES_I18N.SECTION_GROUP_BILLING_INFO_MANAGEMENT },
  ];

export const SYSTEM_ADMIN_ROLES = [
  { code: "ALL_SECTION_GROUP_MANAGEMENT", desc: SYSTEM_ADMIN_ROLES_I18N.ALL_SECTION_GROUP_MANAGEMENT },
  { code: "SECTION_GROUP_CREATE", desc: SYSTEM_ADMIN_ROLES_I18N.SECTION_GROUP_CREATE },
  { code: "PARAMETER_MANAGEMENT", desc: SYSTEM_ADMIN_ROLES_I18N.PARAMETER_MANAGEMENT },
  { code: "SYSTEM_ADMIN_MANAGEMENT", desc: SYSTEM_ADMIN_ROLES_I18N.SYSTEM_ADMIN_MANAGEMENT },
  { code: "DISTRIBUTOR_MANAGEMENT", desc: SYSTEM_ADMIN_ROLES_I18N.DISTRIBUTOR_MANAGEMENT },
  { code: "ALL_DISTRIBUTOR_AGENT_MANAGEMENT", desc: SYSTEM_ADMIN_ROLES_I18N.ALL_DISTRIBUTOR_AGENT_MANAGEMENT },
  { code: "QUOTA_MANAGEMENT", desc: SYSTEM_ADMIN_ROLES_I18N.QUOTA_MANAGEMENT }
];




export const SECTION_GROUP_FUNCTIONS = [
  { code: "UserData", desc: SECTION_GROUP_FUNCTIONS_I18N.UserData },
  { code: "Video", desc: SECTION_GROUP_FUNCTIONS_I18N.Video },
  { code: "Dialog", desc: SECTION_GROUP_FUNCTIONS_I18N.Dialog },
  { code: "RecordList", desc: SECTION_GROUP_FUNCTIONS_I18N.RecordList },
  { code: "STETHOSCOPE", desc: SECTION_GROUP_FUNCTIONS_I18N.STETHOSCOPE },
  { code: "GOST", desc: SECTION_GROUP_FUNCTIONS_I18N.GOST },
  { code: "SST", desc: SECTION_GROUP_FUNCTIONS_I18N.SST },
  { code: "MONITORING", desc: SECTION_GROUP_FUNCTIONS_I18N.MONITORING },
  { code: "VS", desc: SECTION_GROUP_FUNCTIONS_I18N.VS },
  { code: "RSST", desc: SECTION_GROUP_FUNCTIONS_I18N.RSST },
  { code: "MWST", desc: SECTION_GROUP_FUNCTIONS_I18N.MWST },
  { code: "FOOD", desc: SECTION_GROUP_FUNCTIONS_I18N.FOOD },
  { code: "TOMASS", desc: SECTION_GROUP_FUNCTIONS_I18N.TOMASS },
  { code: "PCT", desc: SECTION_GROUP_FUNCTIONS_I18N.PCT },
  { code: "GUIDE_POSTURE", desc: SECTION_GROUP_FUNCTIONS_I18N.GUIDE_POSTURE },
  { code: "TOMASS_SUM", desc: SECTION_GROUP_FUNCTIONS_I18N.TOMASS_SUM },
  { code: "SSTPLUS", desc: SECTION_GROUP_FUNCTIONS_I18N.SSTPLUS },
  { code: "NB4CONFIG", desc: SECTION_GROUP_FUNCTIONS_I18N.NB4CONFIG }
];

export const USER_JOB_TITLES = [
  { code: "NU", desc: USER_JOB_TITLES_I18N.NU }
];

export const STATUS = [
  { code: "open", desc: STATUS_I18N.open },
  { code: "close", desc: STATUS_I18N.close }
];

export const SECTION_GROUP_CONTRACT_CHANNEL = [
  { code: "DISTRIBUTOR", desc: SECTION_GROUP_CONTRACT_CHANNEL_I18N.distributor },
  { code: "DIRECT", desc: SECTION_GROUP_CONTRACT_CHANNEL_I18N.direct },
] as const; // as const をつけることで要素がこの2つに固定され、下記でDISTROBUTOR / DIRECTのニ択になる。これをつけないと実行時に動的に変更される可能性があると解釈され、下記がどんな値でも入る string になってしまう

export type SectionGroupContractChannel = typeof SECTION_GROUP_CONTRACT_CHANNEL[number]['code'];

export const SECTION_BILL_TO_TYPE = [
  { code: "DIRECT", desc: SECTION_BILL_TO_TYPE_I18N.direct },
  { code: "DISTRIBUTOR", desc: SECTION_BILL_TO_TYPE_I18N.distributor },
  { code: "SECTION_GROUP", desc: SECTION_BILL_TO_TYPE_I18N.sectionGroup },
] as const;

export type SectionBillToType = typeof SECTION_BILL_TO_TYPE[number]['code'];

export const BILLING_FREQUENCY = [
  { code: "Monthly", desc: "Monthly" },
  { code: "Annual", desc: "Annual" },
  { code: "Quarterly", desc: "Quarterly" },
  { code: "SemiAnnual", desc: "SemiAnnual" },
];


export const PRICING_MODEL = [
  { code: "Fixed", desc: PRICING_MODEL_I18N.fixed },
  { code: "PerSectionGroup", desc: PRICING_MODEL_I18N.perSectionGroup },
  { code: "PerSection", desc: PRICING_MODEL_I18N.perSection },
  { code: "PerUser", desc: PRICING_MODEL_I18N.perUser },
  { code: "PerDataGB", desc: PRICING_MODEL_I18N.perDataGB },
];

export const PAYMENT_METHOD = [
  { code: "Invoice", desc: PAYMENT_METHOD_I18N.Invoice },
  // { code: "CreditCard", desc: PAYMENT_METHOD_I18N.CreditCard }, // 詳細未定のためひとまずリストから外す。 2026/7/18
  // { code: "DirectDebit", desc: PAYMENT_METHOD_I18N.DirectDebit }, // 詳細未定のためひとまずリストから外す。 2026/7/18
];

